import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '上游新闻•两会云问答';

const route: RouteConfig = {
  path: '/202133LHYWD',
  name: 'LHYWD',
  component: () => import('./Home.vue'),

  meta: {
    title: PAGE_TITLE,
  },
};

export default route;
